<ng-container *ngIf="lateralMenu || carrousel; else pageContent">
  <div class="apply-one-style">
    <div class="site-width">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-3 col-12 menu-sticky" *ngIf="isXlScreen || carrousel">
            <ecm-carrousel [isXlScreen]="isXlScreen"></ecm-carrousel>
          </div>
          <div class="col-12 offset-xl-1 col-xl-7">
            <ng-container *ngTemplateOutlet="pageContent"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #pageContent><ng-content></ng-content></ng-template>
